(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6238],{

/***/ 99146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/full-truck-load",
      function () {
        return __webpack_require__(86253);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ FullTruckLoadPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_service_pages_full_load_booking_FullLoadBooking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99610);
/* harmony import */ var _components_service_pages_constants_full_truck_booking_methods__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51847);




var __N_SSG = true;
function FullTruckLoadPage(param) {
    var faqs = param.faqs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_service_pages_full_load_booking_FullLoadBooking__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        faqs: faqs
    });
};
FullTruckLoadPage.getLayout = _components_service_pages_constants_full_truck_booking_methods__WEBPACK_IMPORTED_MODULE_3__/* .getFullTruckBookingPageLayout */ .Q;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4304,6090,7783,5689,3299,9774,2888,179], function() { return __webpack_exec__(99146); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);